import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import {
  ActionColumn,
} from '../../companies/companies-components/styles';
import { FundNameColumn } from './styles';

const NameColumnHeader = styled(FundNameColumn)`
  ${HeaderMixin}
`;

export default function FundHeader() {
  return (
    <HeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <ActionColumn />
    </HeaderContainer>
  );
}
